import script from "./goRinSyo0050.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0050.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0050.vue?vue&type=style&index=0&id=569f7601&lang=scss"

const __exports__ = script;

export default __exports__